export default "__VITE_ASSET__Drk03fkh__"